module.exports = __webpack_public_path__ + "assets/HKNova-Bold.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Bold.woff2
// module id = 143
// module chunks = 0